export default {
  BUSINESS_LOGIC_ERROR: 422,
  TOO_MANY_REQUESTS: 429,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};
